import React, { useCallback } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { format } from '../../utils/string';
import { Modal, ModalVariant, Flex, FlexItem } from '@patternfly/react-core';
import { confirmButtons } from './ModalButtons';
import { useOrgIdSelect } from 'components/Select/useOrgIdSelect';
import _ from 'lodash';

const ConfirmModalWithOrg = ({ title, icon, isOpen, isLoading, confirmText, onConfirm, item, cancelText, onCancel, template, args, header = null, footer = null, neededPrivilege }) => {
  const T = useTranslation();
  const { renderOrgIdSelect, currentOrg } = useOrgIdSelect({ onChange: null, neededPrivilege: neededPrivilege });

  const _onConfirm = useCallback(() => {
    onConfirm(item, currentOrg);
  }, [onConfirm, item, currentOrg]);

  return (
    <Modal
      variant={ModalVariant.small}
      header={header}
      footer={footer}
      title={title}
      titleIconVariant={icon}
      isOpen={isOpen}
      onClose={isLoading ? null : onCancel}
      actions={confirmButtons({ T, onConfirm: _onConfirm, isDisabled: _.isEmpty(currentOrg), confirmText: confirmText, cancelText: cancelText, onCancel: onCancel, isLoading })}
    >
      <Flex direction={{ default: 'column' }}>
        <FlexItem>
          { format(template, args) }
        </FlexItem>
        <FlexItem>
          { renderOrgIdSelect() }
        </FlexItem>
      </Flex>
    </Modal>
  );
};

export default React.memo(ConfirmModalWithOrg);
